export const IGNORED_AUTOCOMPLETE_GROUP = '__IGNORED_AUTOCOMPLETE_GROUP__';
